import { render, staticRenderFns } from "./SuperAdminDashboard.vue?vue&type=template&id=2eda8f6a&"
import script from "./SuperAdminDashboard.vue?vue&type=script&lang=js&"
export * from "./SuperAdminDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports